import {NoticeDestiny} from "@dropDesk/domain/entities/notices/notices_enum";
import {filtersEnum} from "@dropDesk/domain/entities/reports/report_ticket/report_ticket_enum";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";
import {
    TicketsDescriptionStaticEntity
} from "@dropDesk/domain/entities/ticket_description_static/ticket_description_static.entity";
import {TicketConfig} from "@dropDesk/domain/entities/ticket/ticket_config";

export class DropDeskFiltersEntity {
    ticketFilterStatus?: TicketConfig | null;
    ticketFilterPriority?: TicketConfig | null;
    ticketFilterAttendant?: UserEntity | null;
    ticketFilterUserClient?: UserEntity | null;
    ticketFilterSector?: SectorEntity | null;
    ticketFilterClient?: ClientEntity | null;
    ticketFilterDescriptionStatic?: TicketsDescriptionStaticEntity | null;
    ticketListEmptySector?: boolean | null;
    sectorFilterListableForClients?: 'true' | 'false' | null;
    descriptionStaticFilterListableForClients?: 'true' | 'false' | null;
    noticeFilterDestiny?: NoticeDestiny | null = null;
    reportTicketFilterPerson?: filtersEnum | null = null;
    reportTicketFilterUser?: UserEntity | null = null;
    reportTicketFilterClient?: ClientEntity | null = null;
    reportTicketFilterSector?: SectorEntity | null = null;
    ticketEvaluationFilterValue?: number | null = null;
    reportTicketRateFilterUser?: UserEntity | null = null;
    contactFilterByClient?: ClientEntity | null = null;

    public static fromLocalStorage(filtersStringify: string | null): DropDeskFiltersEntity {
        const json = filtersStringify ? JSON.parse(filtersStringify) : null;
        return new DropDeskFiltersEntity({
            ticketFilterStatus: json && json['ticketFilterStatus'] ? TicketConfig.fromJson(json['ticketFilterStatus']) : null,
            ticketFilterAttendant: json && json['ticketFilterAttendant'] ? UserEntity.fromJson(json['ticketFilterAttendant']) : null,
            ticketFilterUserClient: json && json['ticketFilterUserClient'] ? UserEntity.fromJson(json['ticketFilterUserClient']) : null,
            ticketFilterSector: json && json['ticketFilterSector'] ? SectorEntity.fromJson(json['ticketFilterSector']) : null,
            ticketFilterClient: json && json['ticketFilterClient'] ? ClientEntity.fromJson(json['ticketFilterClient']) : null,
            ticketFilterDescriptionStatic: json && json['ticketFilterDescriptionStatic'] ? TicketsDescriptionStaticEntity.fromJson(json['ticketFilterDescriptionStatic']) : null,
            ticketFilterPriority: json && json['ticketFilterPriority'] ? TicketConfig.fromJson(json['ticketFilterPriority']) : null,
            ticketListEmptySector: json && json['ticketListEmptySector'] ? json['ticketListEmptySector'] : null,
            sectorFilterListableForClients: json && json['sectorFilterListableForClients'] ? json['sectorFilterListableForClients'] : null,
            descriptionStaticFilterListableForClients: json && json['descriptionStaticFilterListableForClients'] ? json['descriptionStaticFilterListableForClients'] : null,
            noticeFilterDestiny: json && json['noticeFilterDestiny'] ? json['noticeFilterDestiny'] : null,
            reportTicketFilterPerson: json && json['reportTicketFilterPerson'] ? json['reportTicketFilterPerson'] : null,
            reportTicketFilterUser: json && json['reportTicketFilterUser'] ? json['reportTicketFilterUser'] : null,
            reportTicketRateFilterUser: json && json['reportTicketRateFilterUser'] ? UserEntity.fromJson(json['reportTicketRateFilterUser']) : null,
            reportTicketFilterClient: json && json['reportTicketFilterClient'] ? ClientEntity.fromJson(json['reportTicketFilterClient']) : null,
            reportTicketFilterSector: json && json['reportTicketFilterSector'] ? SectorEntity.fromJson(json['reportTicketFilterSector']) : null,
            ticketEvaluationFilterValue: json && json['ticketEvaluationFilterValue'] ? json['ticketEvaluationFilterValue'] : null,
            contactFilterByClient: json && json['contactFilterByClient'] ? ClientEntity.fromJson(json['contactFilterByClient']) : null,
        });
    }

    public static eraseFilters(): DropDeskFiltersEntity {
        return new DropDeskFiltersEntity({
            ticketFilterStatus: null,
            ticketFilterAttendant: null,
            ticketFilterUserClient: null,
            ticketFilterSector: null,
            ticketFilterClient: null,
            ticketFilterDescriptionStatic: null,
            ticketFilterPriority: null,
            ticketListEmptySector: false,
            sectorFilterListableForClients: null,
            descriptionStaticFilterListableForClients: null,
            noticeFilterDestiny: null,
            reportTicketFilterPerson: null,
            reportTicketFilterUser: null,
            reportTicketRateFilterUser: null,
            reportTicketFilterClient: null,
            contactFilterByClient: null,
            reportTicketFilterSector: null,
            ticketEvaluationFilterValue: null
        });
    }

    constructor({
                    ticketFilterStatus,
                    ticketFilterAttendant,
                    ticketFilterUserClient,
                    ticketFilterSector,
                    ticketFilterClient,
                    ticketFilterDescriptionStatic,
                    ticketFilterPriority,
                    ticketListEmptySector,
                    sectorFilterListableForClients,
                    descriptionStaticFilterListableForClients,
                    noticeFilterDestiny,
                    reportTicketFilterPerson,
                    reportTicketFilterUser,
                    reportTicketRateFilterUser,
                    reportTicketFilterClient,
                    contactFilterByClient,
                    reportTicketFilterSector,
                    ticketEvaluationFilterValue
                }: {
        ticketFilterStatus?: TicketConfig | null;
        ticketFilterAttendant?: UserEntity | null;
        ticketFilterUserClient?: UserEntity | null;
        ticketFilterSector?: SectorEntity | null;
        ticketFilterClient?: ClientEntity | null;
        ticketFilterDescriptionStatic?: TicketsDescriptionStaticEntity | null;
        ticketFilterPriority?: TicketConfig | null;
        ticketListEmptySector?: boolean | null;
        sectorFilterListableForClients?: 'true' | 'false' | null;
        descriptionStaticFilterListableForClients?: 'true' | 'false' | null;
        noticeFilterDestiny?: NoticeDestiny | null;
        reportTicketFilterPerson?: filtersEnum | null;
        reportTicketFilterUser?: UserEntity | null;
        reportTicketRateFilterUser?: UserEntity | null;
        reportTicketFilterClient?: ClientEntity | null;
        contactFilterByClient?: ClientEntity | null;
        reportTicketFilterSector?: SectorEntity | null;
        ticketEvaluationFilterValue?: number | null;
    }) {
        Object.assign(this, {
            ticketFilterStatus,
            ticketFilterAttendant,
            ticketFilterUserClient,
            ticketFilterSector,
            ticketFilterClient,
            ticketFilterDescriptionStatic,
            ticketFilterPriority,
            ticketListEmptySector,
            sectorFilterListableForClients,
            descriptionStaticFilterListableForClients,
            noticeFilterDestiny,
            reportTicketFilterPerson,
            reportTicketFilterUser,
            reportTicketRateFilterUser,
            reportTicketFilterClient,
            contactFilterByClient,
            reportTicketFilterSector,
            ticketEvaluationFilterValue
        });
    }

    copyWith({
                 ticketFilterStatus,
                 ticketFilterAttendant,
                 ticketFilterUserClient,
                 ticketFilterSector,
                 ticketFilterClient,
                 ticketFilterDescriptionStatic,
                 ticketFilterPriority,
                 ticketListEmptySector,
                 sectorFilterListableForClients,
                 descriptionStaticFilterListableForClients,
                 noticeFilterDestiny,
                 reportTicketFilterPerson,
                 reportTicketFilterUser,
                 reportTicketRateFilterUser,
                 reportTicketFilterClient,
                 contactFilterByClient,
                 reportTicketFilterSector,
                 ticketEvaluationFilterValue,
                 replaceTicketFilterStatusIfNull,
                 replaceTicketFilterAttendantIfNull,
                 replaceTicketFilterUserClientIfNull,
                 replaceTicketFilterSectorIfNull,
                 replaceTicketFilterClientIfNull,
                 replaceTicketFilterDescriptionStaticIfNull,
                 replaceTicketFilterPriorityIfNull,
                 replaceTicketListEmptySectorIfNull,
                 replaceSectorFilterListableForClientsIfNull,
                 replaceDescriptionStaticFilterListableForClientsIfNull,
                 replaceNoticeFilterDestinyIfNull,
                 replaceReportTicketPersonIfNull,
                 replaceReportTicketUserIfNull,
                 replaceReportTicketRateUserIfNull,
                 replaceReportTicketClientIfNull,
                 replaceReportContactFilterByClient,
                 replaceReportTicketSectorIfNull,
                 replaceTicketEvaluationFilterValueIfNull,
             }: {
        ticketFilterStatus?: TicketConfig | null;
        ticketFilterAttendant?: UserEntity | null;
        ticketFilterUserClient?: UserEntity | null;
        ticketFilterSector?: SectorEntity | null;
        ticketFilterClient?: ClientEntity | null;
        ticketFilterDescriptionStatic?: TicketsDescriptionStaticEntity | null;
        ticketFilterPriority?: TicketConfig | null;
        ticketListEmptySector?: boolean | null;
        sectorFilterListableForClients?: 'true' | 'false' | null;
        descriptionStaticFilterListableForClients?: 'true' | 'false' | null;
        replaceTicketFilterStatusIfNull?: boolean | null,
        replaceTicketFilterAttendantIfNull?: boolean | null,
        replaceTicketFilterUserClientIfNull?: boolean | null,
        replaceTicketFilterSectorIfNull?: boolean | null,
        replaceTicketFilterClientIfNull?: boolean | null,
        replaceTicketFilterDescriptionStaticIfNull?: boolean | null,
        replaceTicketFilterPriorityIfNull?: boolean | null,
        replaceTicketListEmptySectorIfNull?: boolean | null,
        replaceSectorFilterListableForClientsIfNull?: boolean | null,
        replaceDescriptionStaticFilterListableForClientsIfNull?: boolean | null,
        replaceNoticeFilterDestinyIfNull?: boolean | null,
        noticeFilterDestiny?: NoticeDestiny | null,
        reportTicketFilterPerson?: filtersEnum | null;
        reportTicketFilterUser?: UserEntity | null;
        reportTicketRateFilterUser?: UserEntity | null;
        reportTicketFilterClient?: ClientEntity | null;
        contactFilterByClient?: ClientEntity | null;
        reportTicketFilterSector?: SectorEntity | null;
        ticketEvaluationFilterValue?: number | null;
        replaceReportTicketPersonIfNull?: boolean | null;
        replaceReportTicketUserIfNull?: boolean | null;
        replaceReportTicketRateUserIfNull?: boolean | null;
        replaceReportTicketClientIfNull?: boolean | null;
        replaceReportContactFilterByClient?: boolean | null;
        replaceReportTicketSectorIfNull?: boolean | null;
        replaceTicketEvaluationFilterValueIfNull?: boolean | null;
    }): DropDeskFiltersEntity {
        return new DropDeskFiltersEntity({
            ticketFilterStatus: replaceTicketFilterStatusIfNull ? ticketFilterStatus : this.ticketFilterStatus,
            ticketFilterAttendant: replaceTicketFilterAttendantIfNull ? ticketFilterAttendant : this.ticketFilterAttendant,
            ticketFilterUserClient: replaceTicketFilterUserClientIfNull ? ticketFilterUserClient : this.ticketFilterUserClient,
            ticketFilterSector: replaceTicketFilterSectorIfNull ? ticketFilterSector : this.ticketFilterSector,
            ticketFilterClient: replaceTicketFilterClientIfNull ? ticketFilterClient : this.ticketFilterClient,
            ticketFilterDescriptionStatic: replaceTicketFilterDescriptionStaticIfNull ? ticketFilterDescriptionStatic : this.ticketFilterDescriptionStatic,
            ticketFilterPriority: replaceTicketFilterPriorityIfNull ? ticketFilterPriority : this.ticketFilterPriority,
            ticketListEmptySector: replaceTicketListEmptySectorIfNull ? ticketListEmptySector : this.ticketListEmptySector,
            sectorFilterListableForClients: replaceSectorFilterListableForClientsIfNull ? sectorFilterListableForClients : this.sectorFilterListableForClients,
            descriptionStaticFilterListableForClients: replaceDescriptionStaticFilterListableForClientsIfNull ? descriptionStaticFilterListableForClients : this.descriptionStaticFilterListableForClients,
            noticeFilterDestiny: replaceNoticeFilterDestinyIfNull ? noticeFilterDestiny : this.noticeFilterDestiny,
            reportTicketFilterSector: replaceReportTicketSectorIfNull ? reportTicketFilterSector : this.reportTicketFilterSector,
            reportTicketFilterPerson: replaceReportTicketPersonIfNull ? reportTicketFilterPerson : this.reportTicketFilterPerson,
            reportTicketFilterClient: replaceReportTicketClientIfNull ? reportTicketFilterClient : this.reportTicketFilterClient,
            contactFilterByClient: replaceReportContactFilterByClient ? contactFilterByClient : this.contactFilterByClient,
            reportTicketFilterUser: replaceReportTicketUserIfNull ? reportTicketFilterUser : this.reportTicketFilterUser,
            reportTicketRateFilterUser: replaceReportTicketRateUserIfNull ? reportTicketRateFilterUser : this.reportTicketRateFilterUser,
            ticketEvaluationFilterValue: replaceTicketEvaluationFilterValueIfNull ? ticketEvaluationFilterValue : this.ticketEvaluationFilterValue,
        })
    }
}
